<template>
	<el-tooltip
		effect="dark"
		:content="text || ''"
		placement="top-start"
		:disabled="!isOverflow"
		popper-class="ellipsis-two-line-tooltip-popper"
	>
		<span ref="contentRef" class="ellipsis-two-line-tooltip">
			<slot>{{ text }}</slot>
		</span>
	</el-tooltip>
</template>

<script setup>
import { ref, nextTick, watch, onMounted, onBeforeUnmount } from 'vue';

const props = defineProps({
	text: {
		type: String,
		default: ''
	}
});

const contentRef = ref(null);
const isOverflow = ref(false);
let resizeObserver = null;

const checkOverflow = () => {
	const element = contentRef.value;
	if (!element) {
		isOverflow.value = false;
		return;
	}
	const overflowY = element.scrollHeight - element.clientHeight > 1;
	const overflowX = element.scrollWidth - element.clientWidth > 1;
	isOverflow.value = overflowY || overflowX;
};

const scheduleCheckOverflow = () => {
	nextTick(() => {
		checkOverflow();
	});
};

onMounted(() => {
	scheduleCheckOverflow();
	if (typeof ResizeObserver !== 'undefined') {
		resizeObserver = new ResizeObserver(() => {
			checkOverflow();
		});
		if (contentRef.value) {
			resizeObserver.observe(contentRef.value);
		}
		return;
	}
	window.addEventListener('resize', checkOverflow);
});

watch(
	() => props.text,
	() => {
		scheduleCheckOverflow();
	}
);

onBeforeUnmount(() => {
	if (resizeObserver) {
		resizeObserver.disconnect();
		resizeObserver = null;
		return;
	}
	window.removeEventListener('resize', checkOverflow);
});
</script>

<style lang="less">
.ellipsis-two-line-tooltip-popper {
	max-width: 400px;
}
</style>
<style lang="less" scoped>
.ellipsis-two-line-tooltip {
	display: -webkit-inline-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 2;
	overflow: hidden;
	text-overflow: ellipsis;
	word-break: break-word;
	line-height: 18px;
	max-height: 36px;
	max-width: 100%;
}
</style>
